import lightFormat from 'date-fns/lightFormat';
import { DATE_PATTERNS } from './datePatterns';

export function getTime(date) {
  const pattern = DATE_PATTERNS.get('time');

  return lightFormat(new Date(date), pattern);
}
